import React from "react";
import { Link } from "react-router-dom";
import myPic from "../img/login-img.jpg";
import myLogo from "../img/my-logo.png";
import google from "../img/google.png";
import { APP_URL } from "../utils/constants";

const Login = () => {
	return (
		<div className="page-fit flex items-center justify-center p-4">
			<div className="w-full sm:w-3/4 shadow-lg h-full flex items-center my-4">
				<div className="w-full h-full hidden lg:inline-block p-4">
					<img
						className="border contrast-150 w-full h-full object-cover rounded-lg"
						src={myPic}
						alt="myLogo"
					></img>
				</div>
				<div className="w-full h-full p-4 flex flex-col items-center justify-center text-gray-600 gap-4">
					<img
						className="h-16 w-16 border border-black rounded-full contrast-150"
						src={myLogo}
						alt="myLogo"
					></img>
					<h1 className="text-xl sm:text-2xl font-bold">{APP_URL}</h1>
					<p className="text-lg sm:text-xl font font-semibold">
						Welcome back!
					</p>
					<div className="text-base font-medium border px-5 py-2 rounded-md cursor-pointer flex gap-3">
						<img className="h-6" src={google} />
						Sign in with Google
					</div>
					<div className="w-full flex items-center gap-2">
						<div className="w-full h-px bg-black opacity-10"></div>
						<div className="w-fit text-nowrap text-xs">
							OR LOGIN WITH EMAIL
						</div>
						<div className="w-full h-px bg-black opacity-10"></div>
					</div>
					<form className="w-full">
						<div className="w-full mb-4">
							<p className="mb-2 text-base opacity-80">
								Email Address
							</p>
							<input
								className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
								type="email"
							></input>
						</div>
						<div className="w-full mb-4">
							<p className="mb-2 text-base opacity-80">
								Password
							</p>
							<input
								className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
								type="password"
							></input>
						</div>
						<button className="w-full py-2 bg-orange-600 rounded-md text-lg text-white font-semibold">
							Login
						</button>
					</form>
					<div className="w-full flex items-center gap-2 mb-4">
						<div className="w-full h-px bg-black opacity-10"></div>
						<Link to="/signup">
							<div className="w-fit text-nowrap text-xs cursor-pointer">
								OR SIGNUP
							</div>
						</Link>
						<div className="w-full h-px bg-black opacity-10"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
